import { DropdownBaseProps } from '../../DropdownBase';
import { DropdownLayoutValueOption } from '../../DropdownLayout';

export type DatePickerDropdownProps = {
  selectedId: number;
  options: NonNullable<DropdownBaseProps['options']>;
  className?: string;
  caption?: string | number;
  dataHook?: string;
  ariaLabel?: string;
  ariaLabelledBy?: string;
  onChange?: (option: DropdownLayoutValueOption) => void;
};
